export const USER_DEFAULT_AVATAR = '/assets/avatars/blank.png';
